import { render, staticRenderFns } from "./bindProject.vue?vue&type=template&id=dab8c34e&scoped=true"
import script from "./bindProject.vue?vue&type=script&lang=js"
export * from "./bindProject.vue?vue&type=script&lang=js"
import style0 from "./bindProject.vue?vue&type=style&index=0&id=dab8c34e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab8c34e",
  null
  
)

export default component.exports